<template>
  <section>
    <h1>Locations</h1>
    <div class="my-3">
      <v-layout row wrap>
        <v-flex xs6 fluid align-center justify-center>
          <v-dialog persistent v-model="modalWindow" max-width="800px">
            <v-btn color="primary" dark slot="activator" v-if="isWriteAvailable" class="mb-2">Add Item</v-btn>
            <v-card v-if="showEditForm">
              <v-card-title>
                <span class="headline">{{ formTitle }} </span>
              </v-card-title>
              <v-card-media v-if="formData.icon" :src="formData.icon" height="300px"/>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <content-field label="Name"
                                     @blur="$v.formData.name.$touch()"
                                     :error="$v.formData.name"
                                     v-model.trim="formData.name"></content-field>
                    </v-flex>
                    <v-flex xs12>
                      <content-field label="Order"
                                     @blur="$v.formData.order.$touch()"
                                     :error="$v.formData.order"
                                     v-model.trim="formData.order"/>
                    </v-flex>

                    <v-layout row justify-space-around>
                      <e-color-picker label="Background color"
                                      v-model="formData.backgroundColor"
                                      @colorChange="onColorChange(['backgroundColor'], $event)"
                                      />

                      <e-color-picker label="Font color"
                                      @colorChange="onColorChange(['fontColor'], $event)"
                                      v-model="formData.fontColor"/>

                      <e-color-picker label="Hover font color"
                                      @colorChange="onColorChange(['hoverFontColor'], $event)"
                                      v-model="formData.hoverFontColor"/>
                    </v-layout>

                    <v-card-title primary-title>Session Configuration</v-card-title>
                    <v-flex xs12>
                      <content-field label="E-mail address"
                                     @blur="$v.formData.sessionConfiguration.emailAddress.$touch()"
                                     :error="$v.formData.sessionConfiguration.emailAddress"
                                     v-model.trim="formData.sessionConfiguration.emailAddress" />
                    </v-flex>
                    <v-layout row justify-space-between>
                      <v-flex xs5>
                        <v-select
                          label="Time font weight"
                          :items="arrayForWeight"
                          v-model="formData.sessionConfiguration.timeFontWeight"/>
                      </v-flex>
                      <v-flex xs5>
                        <v-select
                          label="Title font weight"
                          :items="arrayForWeight"
                          v-model="formData.sessionConfiguration.titleFontWeight"/>
                      </v-flex>
                    </v-layout>

                    <v-flex xs12>
                      <e-color-picker label="Title Font color"
                                      @colorChange="onColorChange(['sessionConfiguration', 'titleColor'], $event)"
                                      v-model="formData.sessionConfiguration.titleColor"/>
                    </v-flex>

                    <v-card-title>Ask question</v-card-title>
                    <v-flex xs12>
                      <content-field label="Question Placeholder"
                                     :error="$v.formData.sessionConfiguration.askQuestion.text"
                                     @blur="$v.formData.sessionConfiguration.askQuestion.text.$touch()"
                                     v-model.trim="formData.sessionConfiguration.askQuestion.text" />
                      <content-field label="Characters limit"
                                     type="number"
                                     :error="$v.formData.sessionConfiguration.askQuestion.charactersLimit"
                                     @blur="$v.formData.sessionConfiguration.askQuestion.charactersLimit.$touch()"
                                     v-model.trim="formData.sessionConfiguration.askQuestion.charactersLimit" />
                      <content-field label="Email Placeholder"
                                     :error="$v.formData.sessionConfiguration.askQuestion.inputPlaceholder"
                                     @blur="$v.formData.sessionConfiguration.askQuestion.inputPlaceholder.$touch()"
                                     v-model.trim="formData.sessionConfiguration.askQuestion.inputPlaceholder" />
                      <content-field label="Title"
                                     :error="$v.formData.sessionConfiguration.askQuestion.title"
                                     @blur="$v.formData.sessionConfiguration.askQuestion.title.$touch()"
                                     v-model.trim="formData.sessionConfiguration.askQuestion.title" />
                    </v-flex>

                    <v-flex xs12>

                      <v-btn color="success" @click="toggleModal">Choose Icon</v-btn>
                      <v-btn :disabled="!formData.icon" color="success" @click="resetIcon">Remove Icon</v-btn>

                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn color="blue darken-1" flat @click.stop="close">Cancel</v-btn>
                <v-btn color="blue darken-1" flat @click.stop="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn color="primary" @click="reset">Reset</v-btn>

          <v-dialog v-model="modalGallery">
            <galleries-list :modalView="true" @pickedImage="setImage"/>
          </v-dialog>

        </v-flex>
        <v-flex xs2 offset-xs4>
          <v-text-field
            append-icon="search"
            label="Search"
            v-model="filterInput"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="locationsList"
        class="elevation-1 wrap"
        :pagination.sync="pagination"
        :total-items="totalItemsInTable"
        :loading="loading"
        item-key="id"
        :disable-initial-sort="true"
      >
        <template slot="items" slot-scope="props">
          <td class="py-4"><v-avatar><img :src="(props.item.icon) || 'http://via.placeholder.com/350x200.jpg'" alt="no image"></v-avatar></td>
          <td class="py-4">{{ props.item.name }}</td>
          <td class="py-4">
            <v-tooltip bottom>
              <div class="selected-color-box"
                   slot="activator"
                   :style="{background: props.item.backgroundColor}"></div>
              <span>{{props.item.backgroundColor}}</span>
            </v-tooltip>
          </td>
          <td class="py-4">
            <v-tooltip bottom>
              <div class="selected-color-box"
                   slot="activator"
                   :style="{background: props.item.fontColor}"></div>
              <span>{{props.item.fontColor}}</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            {{ props.item.order }}
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn color="lime"
                :disabled="!isWriteAvailable"
                fab flat
                slot="activator"
                @click.stop="editItem(props.item)"
              >
                <v-icon>create</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <v-btn
                color="error"
                :disabled="!isWriteAvailable"
                fab flat
                slot="activator"
                @click.stop="deleteLocation(props.item)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
        <template slot="pageText" slot-scope="{}">
          Page {{pagination.page}} of {{totalLocationsPages}}
        </template>
      </v-data-table>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import GalleriesList from '@/components/pages/Gallery/GalleriesList'
import EColorPicker from '@/components/shared/EColorPicker'
import ContentField from '../../../shared/ContentField/index.vue'
import { required, maxLength, email, numeric, minValue } from 'vuelidate/lib/validators'
import debounce from 'lodash.debounce'
import { equals, clone, pathOr } from 'ramda'
import { timeSettings } from '@/modules/settings/'
import _ from 'lodash'
import mixins from '@/utils/mixins'

export default {
  name: 'Locations',
  mixins: [mixins.isWriteAvailable],
  components: {
    ContentField,
    GalleriesList,
    EColorPicker
  },
  data () {
    return {
      showEditForm: true,
      arrayForWeight: [100, 200, 300, 400, 500, 600, 700, 800],
      headers: [
        {text: 'Icon', value: 'icon', search: false, sortable: false, width: 100},
        {text: 'Name', value: 'name', search: false, sortable: true, width: 300},
        {text: 'Background Color', value: '', search: false, sortable: false, width: 50},
        {text: 'Font Color', value: '', search: false, sortable: false, width: 50},
        {text: 'Number of order', value: 'order', search: false, sortable: true, width: 50},
        { text: 'Edit', search: false, sortable: false, align: 'center', width: 50 },
        { text: 'Delete', search: false, sortable: false, align: 'center', width: 50 }
      ],
      loading: true,
      filterInput: '',
      pagination: {
        rowsPerPage: 5
      },
      modalWindow: false,
      modalGallery: false,
      formData: {},
      defaultFormData: {},
      editedIndex: -1,
      comparedParams: null,
      // DON'T DELETE! need for isWriteAvailable mixin
      scopeForWrite: 'agenda:write',
      order: 0
    }
  },
  validations: {
    formData: {
      name: {required},
      backgroundColor: {required},
      fontColor: {required},
      order: {numeric, minValue: minValue(0)},
      hoverFontColor: {required},
      sessionConfiguration: {
        titleColor: {required},
        emailAddress: {required, email},
        timeFontWeight: {required, numeric},
        titleFontWeight: {required, numeric},
        askQuestion: {
          text: {required},
          charactersLimit: {numeric},
          inputPlaceholder: {required},
          title: {required}
        }
      }
    }
  },
  computed: {
    ...mapGetters(['locationsList', 'totalLocationsPages', 'totalLocationsItems']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    totalItemsInTable () {
      return this.totalLocationsItems || (this.totalLocationsPages * this.pagination.rowsPerPage)
    }
  },
  watch: {
    modalWindow (val) {
      if (!val) this.close()
    },
    pagination: {
      handler (val, oldVal) {
        if (!this.isPaginationChanged(val, oldVal)) return
        this.getLocations()
      },
      deep: true
    },
    filterInput () {
      this.getLocations()
    }
  },
  created () {
    let defaultForm = {
      id: '',
      name: '',
      icon: '',
      backgroundColor: { hex: '#0000ff' },
      fontColor: { hex: '#0000ff' },
      hoverFontColor: { hex: '#0000ff' },
      sessionConfiguration: {
        titleColor: { hex: '#0000ff' },
        emailAddress: '',
        timeFontWeight: 300,
        titleFontWeight: 500,
        askQuestion: {
          text: '',
          charactersLimit: null,
          inputPlaceholder: '',
          title: ''
        }
      },
      order: 0
    }
    this.formData = _.cloneDeep(defaultForm)
    this.defaultFormData = _.cloneDeep(defaultForm)
  },
  methods: {
    ...mapActions(['getLocationsList', 'addLocationList', 'showResultErrorMessage', 'removeLocation']),
    // because created hook inside e-color-piker works only once we force conditional rendering of the form
    reloadForm () {
      this.showEditForm = false
      setTimeout(() => {
        this.showEditForm = true
      }, 500)
    },
    toggleModal () {
      this.modalGallery=!this.modalGallery
    },
    resetIcon () {
      this.formData.icon = ''
    },
    editItem (item) {
      const titleColor = item.sessionConfiguration.titleColor
      this.editedIndex = this.locationsList.indexOf(item)
      this.formData = Object.assign({}, item)
      this.formData.backgroundColor = { hex: item.backgroundColor }
      this.formData.fontColor = { hex: item.fontColor }
      this.formData.hoverFontColor = { hex: item.hoverFontColor }
      const titleColorHexCode = typeof titleColor === 'string' ? titleColor : titleColor.hex
      this.formData.sessionConfiguration.titleColor = { hex: titleColorHexCode }
      this.modalWindow = true
    },
    async deleteLocation (item) {
      await this.removeLocation(item.id)
      this.getLocations()
    },
    close () {
      this.$v.formData.$reset()
      this.modalWindow = false
      this.formData = _.cloneDeep(this.defaultFormData)
      this.editedIndex = -1
      this.reloadForm()
    },
    async save () {
      this.$v.formData.$touch()
      if (this.$v.formData.$invalid) {
        return false
      }
      const payload = { ...this.formData }
      payload.order = parseInt(payload.order)
      payload.backgroundColor = pathOr('#000000', ['backgroundColor', 'hex'], this.formData)
      payload.fontColor = pathOr('#000000', ['fontColor', 'hex'], this.formData)
      payload.hoverFontColor = pathOr('#000000', ['hoverFontColor', 'hex'], this.formData)
      payload.sessionConfiguration.titleColor = pathOr('#000000', ['sessionConfiguration', 'titleColor', 'hex'], this.formData)
      try {
        if (this.editedIndex > -1) {
          await this.addLocation(payload)
        } else {
          delete payload.id
          await this.addLocation(payload)
        }
      } catch (err) {
        throw err
      }
      this.getLocations(true)
    },
    reset () {
      this.filterInput = ''
      this.pagination.sortBy = null
      this.pagination.descending = false
      this.getLocations()
      this.order = 0
    },
    setImage (item) {
      this.formData.icon = item.imagesUrls.originalImageUrl
      this.modalGallery = false
    },
    onColorChange (varData, color) {
      if (varData.length > 1) {
        this.formData[varData[0]][varData[1]] = color
      } else {
        this.formData[varData[0]] = color
      }
    },
    getLocations: debounce(async function (isModal) {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let itemsOnPage = equals(rowsPerPage, -1) ? this.totalLocationsItems : rowsPerPage
      const sort = descending ? 'Desc' : 'Asc'
      const name = sortBy ? sortBy[0].toUpperCase() + sortBy.slice(1) : null
      const newPage = page - 1
      const pageCheck = newPage > 0 ? newPage : 0
      const getParams = {
        page: pageCheck,
        itemsOnPage,
        filter: this.filterInput,
        sort,
        name
      }
      try {
        if (!equals(getParams, this.comparedParams) || isModal) await this.getLocationsList(getParams)
        this.loading = false
        this.comparedParams = clone(getParams)
      } catch (err) {
        this.showResultErrorMessage(err)
      }
    }, timeSettings.delayTime),
    async addLocation (item) {
      try {
        await this.addLocationList({...item})
        await this.getLocations()
        this.modalWindow = false
      } catch (err) {
        throw err
      }
    },
    isPaginationChanged (val, oldVal) {
      return val.rowsPerPage !== oldVal.rowsPerPage ||
        val.sortBy !== oldVal.sortBy ||
        val.descending !== oldVal.descending ||
        val.page !== oldVal.page
    }
  },
  async mounted () {
    await this.getLocations()
  }
}
</script>

<style type="scss">
.arrow {
  margin: 0 -10px;
}

.arrow i {
  font-size: 16px;
}

.selected-color-box {
  display: inline-block;
  width: 27px;
  height: 27px;
  margin-left: 10px;
  border-radius: 2px;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
}

.card__media__background {
  background-size: contain !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Agenda/Locations/index.vue